var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-toolbar',{attrs:{"color":"primary","dark":"","app":"","clipped-right":""}},[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":_vm.goBack}},[_c('v-icon',[_vm._v("close")])],1),_c('v-toolbar-title',[_vm._v("\n      DiTech Trasferte\n    ")]),_c('v-spacer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }